import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { greyScaleColors, semanticColors } from '../../Globals/styles'
import TimeWheelInput from '../../Common/timeWheelInput';
import Waves from 'node-waves'

class WorkplaceDropModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bookedWorkplace: {
        workplaceId: this.props.droppedWorkplace.workplaceId,
        startTime: 7,
        endTime: 13,
        isDelete: false
      }
    }
  }
  componentWillMount = () => {
    const { droppedWorkplace: { editValues }} = this.props;
    if(editValues){
      this.setState({
        bookedWorkplace: {
          workplaceId: this.props.droppedWorkplace.workplaceId,
          startTime: editValues.startTime,
          endTime: editValues.endTime
        },
        isEdit: true
      })
    }
  };
  onChangeStartTime = (val) => {
    let endTime = val > this.state.bookedWorkplace.endTime ? val : this.state.bookedWorkplace.endTime;
    this.setState({
      bookedWorkplace: {
        workplaceId: this.state.bookedWorkplace.workplaceId,
        startTime: val,
        endTime: endTime
      }
    })
  };
  onChangeEndTime = (val) => {
    let startTime = val < this.state.bookedWorkplace.startTime ? val : this.state.bookedWorkplace.startTime;
    this.setState({
      bookedWorkplace: {
        workplaceId: this.state.bookedWorkplace.workplaceId,
        endTime: val,
        startTime: startTime
      }
    })
  };
  componentDidMount = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };
  componentDidUpdate = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };
  onSave = () => {
    const { droppedWorkplace, addWorkplaceToWeekday } = this.props;
    if(this.state.isEdit)
      addWorkplaceToWeekday(this.state.bookedWorkplace, droppedWorkplace.weekdayIndex, droppedWorkplace.employeeIndex, droppedWorkplace.editValues.bookingIndex)
    else
      addWorkplaceToWeekday(this.state.bookedWorkplace, droppedWorkplace.weekdayIndex, droppedWorkplace.employeeIndex)
  };
  onDelete = () => {
    const { droppedWorkplace, attemptDeleteBooking } = this.props;
    if(this.state.isDelete)
      attemptDeleteBooking(this.state.bookedWorkplace, droppedWorkplace.weekdayIndex, droppedWorkplace.employeeIndex, droppedWorkplace.editValues.bookingIndex)
    else {
      this.setState({
        isDelete: true
      })
    }
  };
  render () {
    const { bookedWorkplace, isEdit, isDelete } = this.state;
    const { cancelWorkplaceDrop } = this.props;
    return (
      <div>
        <div style={styles.overlay}></div>
        <div style={[styles.modal, isDelete && styles.isDelete]}>
          {isDelete ?
            <div>
              <i
                className="fa fa-times"
                aria-hidden="true"
                style={styles.closeIcon}
                onClick={cancelWorkplaceDrop}></i>
              <div>
                <h3>Er du sikker på du vil slette?</h3>
              </div>
              <button style={[styles.button, styles.deleteBtn]} onClick={this.onDelete} className="btn btn-danger waves-btn"> Ja! </button>

            </div>
            :
            <div>
              <i
                className="fa fa-times waves-icon"
                aria-hidden="true"
                style={styles.closeIcon}
                onClick={cancelWorkplaceDrop}></i>
              <div>
                <h3>Start</h3>
                <div style={styles.startTimeInput}>
                  <TimeWheelInput
                    value={bookedWorkplace.startTime}
                    onChange={this.onChangeStartTime}
                  />
                </div>
              </div>
              <div>
                <h3>Slut</h3>
                <div style={styles.startTimeInput}>
                  <TimeWheelInput
                    value={bookedWorkplace.endTime}
                    onChange={this.onChangeEndTime}
                  />
                </div>
              </div>
              {isEdit ?
              <button style={styles.button} onClick={this.onDelete} className="btn btn-danger waves-btn pull-left">Slet</button>
              :
              null}
              <button style={styles.button} onClick={this.onSave} className="btn btn-success waves-btn pull-right">Gem</button>
            </div>
          }
        </div>
      </div>
    );
  }
}

var styles = {
  overlay: {
    width:'100%',
    height: '100%',
    position: 'fixed',
    top: '0',
    left: '0',
    backgroundColor: greyScaleColors.grey,
    opacity: '0.6',
    zIndex: '10'
  },
  modal:{
    position: 'fixed',
    top: '50%',
    left: '50%',
    zIndex: '11',
    backgroundColor: semanticColors.default,
    width: '240px',
    height: '220px',
    marginTop: '-110px',
    marginLeft: '-120px',
    textAlign: 'center',
    borderRadius: '2px',
    lineHeight: '40px',
    paddingTop: '10px'
  },
  startTimeInput: {
    display: 'inline-block',
    height: '40px',
    width: '240px'
  },
  button:{
    borderRadius: '2px',
    margin: '18px',
    minWidth: '70px'
  },
  closeIcon: {
    position: 'absolute',
    top: '0px',
    right: '0px',
    fontSize: '20px',
    height: '30px',
    lineHeight: '30px',
    width: '30px',
    zIndex: '10'
  },
  isDelete: {
    paddingTop: '70px'
  }
}

  WorkplaceDropModal.propTypes = {
    droppedWorkplace: PropTypes.shape({
      employeeIndex: PropTypes.number.isRequired,
      weekdayIndex: PropTypes.number.isRequired,
      workplaceId: PropTypes.string.isRequired,
      editValues: PropTypes.shape({
        startTime: PropTypes.number.isRequired,
        endTime: PropTypes.number.isRequired,
        bookingIndex: PropTypes.number.isRequired
      })
    }),
    addWorkplaceToWeekday: PropTypes.func.isRequired,
    cancelWorkplaceDrop: PropTypes.func.isRequired,
    attemptDeleteBooking: PropTypes.func.isRequired
  };
export default Radium(WorkplaceDropModal)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/EmployeeWeekOverview/workplaceDropModal.jsx